// src/components/pages/Movimento/profiles/entrada/index.js
import { baseDefaults } from "../base/defaults";

export const entradaProfile = {
    ...baseDefaults,
    natureza: "Entrada",
    parceiroVai: "destinatario",
};
